import { useProjectSidebarStore } from "@/zapi-frontend/stores/projectSidebarStore";
import { AppButton, Typography } from "@libs/zapi-ui/custom";
import { CardHeader } from "@libs/zapi-ui/shadcn";
import { XIcon } from "@phosphor-icons/react";

export function IntelligenceQuestionsHeader() {
  const { closeHandler } = useProjectSidebarStore();

  return (
    <CardHeader className="flex flex-col border border-innoveraZinc-100 rounded-t-[8px] text-zinc-500 text-sm py-2 px-4">
      <div className="flex items-center justify-between">
        <Typography variant="label2" className="text-zinc-900">
          Intelligence Questions
        </Typography>

        <AppButton appearance="text" size="icon" onClick={closeHandler}>
          <XIcon />
        </AppButton>
      </div>
    </CardHeader>
  );
}
